import { OrderStep } from '../constants';

export enum OrderSection {
	TypeOfProsthesis = 1,
	Customize,
	SocketDetails,
	ClientsDetails,
	OrderPreview,
	Scan,
	Alignment,
	Files,
	Details,
	ShippingAddress,
	OrderFinalise,
	Feedback,
	SocketFittingFiles,
	SocketFittingFinalise,
}

export const orderSections: Record<OrderSection, OrderStep[]> = {
	[OrderSection.TypeOfProsthesis]: [OrderStep.New],
	[OrderSection.Customize]: [
		OrderStep.HandType,
		OrderStep.Terminal,
		OrderStep.Socket,
		OrderStep.ExtraParameters,
		OrderStep.ColorPattern,
		OrderStep.SkinGlove,
		OrderStep.Elbow,
		// GLA-63: bez tego wpisu zakładka „Customizer" nie podświetla się na ekranie
		// konfiguracji Espire, a szkic zapisany na tym kroku nie pokazuje postępu —
		// `sectionForStep()` nie znajduje sekcji (znalazł Cerber, r6).
		OrderStep.EspireConfiguration,
	],
	[OrderSection.SocketDetails]: [OrderStep.OuterSocket, OrderStep.CheckSocket],
	[OrderSection.ClientsDetails]: [OrderStep.ClientDetails],
	[OrderSection.OrderPreview]: [OrderStep.Preview],
	[OrderSection.Scan]: [OrderStep.AfterConfirmation, OrderStep.AddingScan],
	[OrderSection.Alignment]: [OrderStep.Alignment],
	[OrderSection.Files]: [OrderStep.Files],
	[OrderSection.Details]: [OrderStep.Details],
	[OrderSection.ShippingAddress]: [OrderStep.ShippingAddress],
	[OrderSection.OrderFinalise]: [OrderStep.Finalise],
	[OrderSection.Feedback]: [OrderStep.Feedback],
	[OrderSection.SocketFittingFiles]: [OrderStep.SocketFittingFiles],
	[OrderSection.SocketFittingFinalise]: [OrderStep.SocketFittingFinalise],
};

export namespace OrderSection {
	// eslint-disable-next-line no-inner-declarations
	export function findSection(step: OrderStep): OrderSection | null {
		const entry = Object.entries(orderSections).find(([, steps]) => steps.includes(step));

		if (!entry) {
			return null;
		}

		return +entry[0];
	}
}
